import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Input } from 'react-materialize';

import * as actions from '../../actions';
import { formatNumber } from '../../helpers';

class DeviceSelect extends Component {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    const { startDate, endDate, selectedSite, auth, country } = nextProps;
    const diffEndDate = endDate      !== this.props.endDate;
    const diffAuth    = auth         !== this.props.auth;
    const diffCountry = country      !== this.props.country;
    const diffSite    = selectedSite !== this.props.selectedSite

    if (
      !startDate            ||
      !endDate              ||
      !this.props.startDate ||
      !this.props.endDate
    )
      return;

    if (diffEndDate || diffAuth || diffCountry || diffSite) {
      this.props.fetchDeviceList({
        startDate,
        endDate,
        country,
        siteUrl: selectedSite
      });
    }
  }

  handleChange(event) {
    const { selectDevice } = this.props;
    selectDevice(event.target.value);
  }

  render() {
    const { deviceList } = this.props;

    return (
      <Input
        className="device-select"
        type="select"
        label="Device (# of clicks)"
        onChange={this.handleChange}
        s={6} m={6} l={2}
      >
        <option value="all">All</option>
        {deviceList.map((obj, index) => {
          return (
            <option key={index} value={obj.keys[0]}>
              {this.formatDeviceText(obj.keys[0])} ({formatNumber(obj.clicks)})
            </option>
          );
        })}
      </Input>
    );
  }

  formatDeviceText(string) {
    return string.replace(/\w\S*/g, function(word) {
      return word.charAt(0) + word.slice(1).toLowerCase();
    });
  }
}

function mapStateToProps({
  device,
  deviceList,
  startDate,
  endDate,
  selectedSite,
  auth,
  country
}) {
  return {
    device,
    deviceList,
    startDate,
    endDate,
    selectedSite,
    auth,
    country
  };
}

export default connect(mapStateToProps, actions)(DeviceSelect);



// WEBPACK FOOTER //
// ./src/components/Dashboard/DeviceSelect.js